import $ from 'jquery';

export default class {
  init() {
    $(document).on('click', '.js-search-results-entries li a', (e) => {
     
      window.dataLayer.push({
        'event': 'search-click',
        'pdf-search-click-info': {
          'name': e.target.innerText,
          'placement-in-results': this.getResultNumber(e.target),
          'query': getQueryString()
        }
      });
    });

    document.addEventListener('search', this.addDataLayerInfo);

    $('.search-info-pi-list .pi-link').on('click', (e) => {
      const urlPieces = e.target.href.split('/');
      const filename = urlPieces[urlPieces.length - 1];
 
      window.dataLayer.push({
        'event': 'search-result-pi-click',
        'name': filename
      });
    });
  }
  getResultNumber(el) {
    let current = el.parentElement;
    let index = 1;
    // gets result number in list
    while ((current = current.previousElementSibling) !== null) {
      index += 1;
    }
    return index;
  }
  
  addDataLayerInfo (e) {
    const detail = e.detail;
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'search',
        'search-detail': {
          'product': detail.product,
          'query': getQueryString(),
          'status-of-search': detail.status,
        }
      });
    }
  }
}


function getQueryString() {
  return document.location.href.substring(document.location.href.indexOf('?'), document.location.href.length);
}


// WEBPACK FOOTER //
// ./src/assets/js/project/search/events.js